interface FinancialsCostList {
  [key: string]: number[];
}
// ----------------------------------------------------------------------
export const _financial_cost_list: FinancialsCostList = {
  License_0: [
    6555300, 6692656, 6833040, 6976526, 7123189, 7273106, 7426357, 7583023,
    7743189, 7906941
  ],
  Maintenance_0: [
    2334954, 2411653, 2491236, 2573822, 2659533, 2748499, 2840855, 2936740,
    3036300, 3139689
  ],
  Infra_0: [
    1963272, 2013787, 2065819, 2119421, 2174648, 2231556, 2290207, 2350662,
    2412985, 2477243
  ],
  Staff_0: [
    4626544, 4759075, 4896056, 5037659, 5184058, 5335440, 5491996, 5653927,
    5821440, 5994752
  ],
  Hosting_0: [
    1106636, 1137519, 1169413, 1202356, 1236389, 1271551, 1307886, 1345439,
    1384255, 1424383
  ],
  Upgrades_0: [
    1190000, 1953750, 948019, 855875, 1394389, 1699636, 1850695, 1020646,
    1276575, 2334571
  ],
  'Help Desk_0': [
    693583, 707455, 721604, 736036, 750757, 765772, 781087, 796709, 812643,
    828896
  ],
  Other_0: [
    2002000, 2363730, 2191605, 2296098, 2407720, 2657024, 2854601, 2791095,
    2937195, 3243647
  ]
};
